/**
 * Our Mission Block - Frontend JavaScript
 * Handles auto-scrolling marquee animation for image gallery
 */
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        const galleries = document.querySelectorAll('.our-mission__gallery[data-marquee="true"]');

        galleries.forEach(function(gallery) {
            const tracks = gallery.querySelectorAll('.our-mission__gallery-track');

            if (tracks.length !== 2) {
                return;
            }

            const firstTrack = tracks[0];
            const secondTrack = tracks[1];

            // Calculate the width of the first track
            const trackWidth = firstTrack.scrollWidth;

            // Set CSS custom property for animation
            gallery.style.setProperty('--track-width', trackWidth + 'px');

            // Add animation classes
            gallery.classList.add('is-animating');

            // Pause animation on hover
            gallery.addEventListener('mouseenter', function() {
                gallery.classList.add('is-paused');
            });

            gallery.addEventListener('mouseleave', function() {
                gallery.classList.remove('is-paused');
            });

            // Handle reduced motion preference
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

            function handleReducedMotion() {
                if (prefersReducedMotion.matches) {
                    gallery.classList.add('reduce-motion');
                } else {
                    gallery.classList.remove('reduce-motion');
                }
            }

            handleReducedMotion();
            prefersReducedMotion.addEventListener('change', handleReducedMotion);
        });
    });
})();
